/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "admin/components/MDBox";
import MDTypography from "admin/components/MDTypography";
import MDBadge from "admin/components/MDBadge";
import MDButton from "admin/components/MDButton";

export default function data(users = [], onEdit, onDelete) {
    return {
        columns: [
            { Header: "first name", accessor: "firstName", width: "12%", align: "left" },
            { Header: "last name", accessor: "lastName", width: "12%", align: "left" },
            { Header: "company", accessor: "company", align: "left" },
            { Header: "email", accessor: "email", width: "18%", align: "left" },
            { Header: "phone", accessor: "phone", align: "center" },
            { Header: "role", accessor: "role", align: "center" },
            { Header: "status", accessor: "status", align: "center" },
            { Header: "actions", accessor: "actions", align: "center" },
        ],

        rows: (Array.isArray(users) ? users : []).map((user) => ({
            firstName: (
                <MDTypography variant="caption" color="text" fontWeight="medium">
                    {user.firstName}
                </MDTypography>
            ),
            lastName: (
                <MDTypography variant="caption" color="text" fontWeight="medium">
                    {user.lastName}
                </MDTypography>
            ),
            company: (
                <MDTypography variant="caption" color="text" fontWeight="medium">
                    {user.company || "-"}
                </MDTypography>
            ),
            email: (
                <MDTypography variant="caption" color="text" fontWeight="medium">
                    {user.email}
                </MDTypography>
            ),
            phone: (
                <MDTypography variant="caption" color="text" fontWeight="medium">
                    {user.phoneNo || "-"}
                </MDTypography>
            ),
            role: (
                <MDBox ml={-1}>
                    <MDBadge
                        badgeContent={user.role}
                        color={user.role === "admin" ? "success" : "info"}
                        variant="gradient"
                        size="sm"
                    />
                </MDBox>
            ),
            status: (
                <MDBox ml={-1}>
                    <MDBadge
                        badgeContent={user.status}
                        color={user.status === "active" ? "success" : "dark"}
                        variant="gradient"
                        size="sm"
                    />
                </MDBox>
            ),
            actions: (
                <MDBox display="flex" alignItems="center" justifyContent="center">
                    <MDButton variant="text" color="info" iconOnly onClick={() => onEdit && onEdit(user)}>
                        <Icon>edit</Icon>
                    </MDButton>
                    <MDButton variant="text" color="error" iconOnly onClick={() => onDelete && onDelete(user._id)}>
                        <Icon>delete</Icon>
                    </MDButton>
                </MDBox>
            ),
        })),
    };
}
